import styled from 'styled-components';
import media from '~/utils/media';
import arrow from '../../assets/select_arrow.svg';

export const NameWrapper = styled.div `
  position: absolute;
  top: 8%;
  left: 5.2%;
  display: flex;
  align-items: center;
  width: 82.89%;
  height: 7.5%;
`

export const PhoneNumberWrapper = styled.div`
  position: absolute;
  top: 18.9%;
  left: 5.2%;
  display: flex;
  align-items: center;
  width: 82.89%;
  height: 7.5%;
`

export const Notice1 = styled.img `
  position: absolute;
  top: 30%;
  left: 3.42%;
  width: 84.69%;
`

export const ApplyDateWrapper = styled.div`
  position: absolute;
  top: 39.07%;
  left: 5.2%;
  display: flex;
  align-items: center;
  width: 82.89%;
  height: 9.24%;
`

export const ApplyLocationWrapper = styled.div`
    position: absolute;
    top: 52.52%;
    left: 5.2%;
    display: flex;
    align-items: center;
    width: 82.89%;
    height: 9.24%;
`

export const AreaWrapper = styled.div`
    position: absolute;
    top: 65.96%;
    left: 5.2%;
    display: flex;
    align-items: center;
    width: 82.89%;
    height: 9.24%;
`

export const Notice2 = styled.img `
  position: absolute;
  top: 78.57%;
  left: 3.42%;
  width: 91.04%;
`

export const MainInfoWrapper = styled.div`
  position: absolute;
  top:2%;
  left: 2.9%;
  margin: 0 auto;
  width: 94%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  font-weight: 700;
  font-size: 20px;

  ${media.mobileLarge`
    font-size: 16px;
    svg {
      height: 14px;
    }
  `}

  ${media.mobileMid`
    font-size: 12px;
    svg {
      height: 14px;
    }
  `}

  ${media.mobileSmall`
    font-size: 12px;
    svg {
      height: 14px;
    }
  `}

  .Title {
    width: 15.71%;
    text-align: right;
    white-space: nowrap;
    font-weight: 700;
    color: #326CF9;
  }

  .Divider {
    padding: 0.5% 16px 0;
  }

  .ContentText {
    font-weight: 500;
    white-space: nowrap;
    color: #222222;
    font-size: 20px;

    ${media.mobileLarge`
      font-size: 16px;
    `}

    ${media.mobileMid`
      font-size: 12px;
    `}

    ${media.mobileSmall`
      font-size: 12px;
    `}
  }

  .ContentWrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    color: #979797;
  }

  .Description {
    margin-left: auto;
    white-space: nowrap;
    font-weight: 500;
    font-size: 14px;

    ${media.mobileMid`
      font-size: 10px;
    `}
    ${media.mobileSmall`
      font-size: 10px;
    `}
    }
  `

export const SearchArea = styled.button`
  display: block;
  height: 100%;
  padding: 0 8px 0 10px;
  color: ${({ value }) => value ? '#222222' : '#979797'};
  font-weight: 400;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  box-sizing: border-box;
  background-color: #fff;
  background-size: 10px 6px;
  outline: none;
  appearance: none;
  text-align: left;
  font-size: 14px; 

  ${media.mobileLarge`
    font-size: 10px;
  `}

  ${media.mobileMid`
    font-size: 10px;
  `}

  ${media.mobileSmall`
    font-size: 10px;
  `}
  width:${({ width }) => `${width}`};
`

export const Select = styled.select`
  display: block;
  height: 100%;
  padding: 0 8px 0 10px;
  color: ${({ value }) => String(value) ? '#222222' : '#979797'};
  font-weight: 400;
  border: 1px solid #EDEDED;
  border-radius: 2px;
  box-sizing: border-box;
  background: url(${arrow}) right 8px center no-repeat;
  background-color: #fff;
  background-size: 10px 6px;
  outline: none;
  appearance: none;
  font-size: 14px; 

  ${media.mobileLarge`
    font-size: 10px;
  `}

  ${media.mobileMid`
    font-size: 10px;
  `}

  ${media.mobileSmall`
    font-size: 10px;
  `}
  &::-ms-expand {
   // IE10 까지만 화살표 제거됨...
   display: none;
  }
  &::-ms-value {
   background: none;
   color: rgb(76, 76, 76);
  }
  &:focus {
   border-color: rgb(50, 108, 249);
  }
  &:disabled {
   color: rgb(174, 174, 174);
   border-color:  rgb(231, 231, 231);
   background-color: rgb(250, 250, 250);
  }
  width:${({ width }) => `${width}`};
`;

